<template>
  <div class="home-view">
    <the-header :isHone="true"></the-header>
    <div class="bigBox" id="home-view">
      HOME
    </div>
  </div>
</template>

<script>
import TheHeader from '@/views/frame/TheHeader'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'overView',
  props: [],
  components: { TheHeader },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['rootMenus', 'userInfo'])
  },
  watch: {},
  methods: {
    ...mapMutations(['setRootMenu', 'setMainStyle', 'setLeafMenu', 'addTab'])
  },
  created () {},
  mounted () {}
}
</script>

<style lang="less" scoped>
.home-view {
  width: 100%;
  height: 100%;
  position: relative;
  .bigBox {
    padding: 25px 32px 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 60px;
    bottom: 0;
    background: #f4f4f4;
    overflow: hidden;
    overflow-y: scroll;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color:#22a6c9;
  }
}
</style>
